import { motion, useReducedMotion } from 'motion/react';
import { cn } from '@restworld/utils-common';

export type WiggleProps = {
  children: React.ReactNode;
  className?: string;
  /** Seconds of stillness between two wiggles. */
  repeatDelay?: number;
};

/**
 * Rocks its children left and right for a moment, then waits and does it again. Meant for a small
 * icon that should catch the eye (the referral gift, RW-360) without moving the text around it.
 * Stays still for people who asked their system for reduced motion.
 */
export function Wiggle({ children, className, repeatDelay = 3.5 }: WiggleProps) {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) {
    return <span className={cn('inline-flex', className)}>{children}</span>;
  }

  return (
    <motion.span
      className={cn('inline-flex', className)}
      animate={{ rotate: [0, -12, 12, -8, 8, 0] }}
      transition={{ duration: 0.6, ease: 'easeInOut', repeat: Infinity, repeatDelay }}
    >
      {children}
    </motion.span>
  );
}
